export default "__VITE_ASSET__88869765__"